export default "__VITE_ASSET__BbaiqhkT__"